import { ModalidadI } from "interfaces/Modalidad";
import { ReactNode, useState } from "react";

interface Props {
  elemento: ModalidadI;
  renderActions?: (elemento: ModalidadI) => ReactNode;
}

export const ModalidadRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
